import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getTemplates, getTemplate, runTemplate, getTestDataReference } from '../services/templates';

export const templateKeys = {
  all: ['templates'],
  detail: (id) => ['templates', id],
  testData: ['test-data'],
};

export function useTemplates() {
  return useQuery({
    queryKey: templateKeys.all,
    queryFn: getTemplates,
  });
}

export function useTemplate(templateId) {
  return useQuery({
    queryKey: templateKeys.detail(templateId),
    queryFn: () => getTemplate(templateId),
    enabled: !!templateId,
  });
}

export function useRunTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: runTemplate,
    onSuccess: () => {
      // Invalidate logs/usage since we logged the template run
      queryClient.invalidateQueries({ queryKey: ['logs'] });
      queryClient.invalidateQueries({ queryKey: ['usage'] });
    },
  });
}

export function useTestDataReference() {
  return useQuery({
    queryKey: templateKeys.testData,
    queryFn: getTestDataReference,
    staleTime: Infinity, // Static data, never refetch
  });
}
